import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MiddleWeightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-middleWeight"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M53.645072 7.83770686C53.790644 7.41350483 54.3620264 7.39019559 54.557813 7.76068662L54.5937264 7.84610252 58.6296238 20.3218289 57.6781711 20.6296238 54.104 9.58 50.3106349 20.6352212 49.3647788 20.3106349 53.645072 7.83770686ZM13.645072 7.83770686C13.790644 7.41350483 14.3620264 7.39019559 14.557813 7.76068662L14.5937264 7.84610252 18.6296238 20.3218289 17.6781711 20.6296238 14.104 9.58 10.3106349 20.6352212 9.36477881 20.3106349 13.645072 7.83770686Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <g transform="translate(7.212 4)">
          <path
            d="M14 15C14 18.866 10.866 22 7 22 3.134 22 0 18.866 0 15L14 15ZM53.7881 15C53.7881 18.866 50.6541 22 46.7881 22 42.9221 22 39.7881 18.866 39.7881 15L53.7881 15Z"
            fill="#0050B3"
            className={styles.interactiveColor}
          />
          <path
            d="M26.7881,-1 C27.3009358,-1 27.7236072,-0.61395981 27.7813723,-0.116621125 L27.7881,0 L27.7881,26 C27.7881,26.5522847 27.3403847,27 26.7881,27 C26.2752642,27 25.8525928,26.6139598 25.7948277,26.1166211 L25.7881,26 L25.7881,0 C25.7881,-0.55228475 26.2358153,-1 26.7881,-1 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M46.7881,3 C47.3403847,3 47.7881,3.44771525 47.7881,4 C47.7881,4.51283584 47.4020598,4.93550716 46.9047211,4.99327227 L46.7881,5 L6.7881,5 C6.23581525,5 5.7881,4.55228475 5.7881,4 C5.7881,3.48716416 6.17414019,3.06449284 6.67147887,3.00672773 L6.7881,3 L46.7881,3 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M20.7881 28 32.7881 28 32.7881 28C32.7881 26.895 31.8931 26 30.7881 26L22.7881 26C21.6831 26 20.7881 26.895 20.7881 28ZM23.7881 4C23.7881 5.657 25.1311 7 26.7881 7 28.4451 7 29.7881 5.657 29.7881 4 29.7881 2.343 28.4451 1 26.7881 1 25.1311 1 23.7881 2.343 23.7881 4"
            fill="#00000"
            className={styles.defaultColor}
          />
        </g>
      </g>
    </Icon>
  )
}
